module.exports = __webpack_public_path__ + "img/kinder_digital.2a5430e2.jpg";